// extracted by mini-css-extract-plugin
export default {"pm":"Navbar_pm__y7ZD3","navsty":"Navbar_navsty__XQr96","m":"Navbar_m__iaq7n","txt":"Navbar_txt__ZMhLX","innertxt":"Navbar_innertxt__JePh0"};